import classNames from 'classnames';
import React, { useState } from 'react';

const AuthSelector = ({
	label,
	value,
	options,
	onChange,
}: {
	label?: string;
	value?: { label: string; description?: React.ReactNode; value: string };
	options: { label: string; description?: React.ReactNode; value: string }[];
	onChange?: (value: { label: string; description?: React.ReactNode; value: string }) => void;
}) => {
	const [selected, setSelected] = useState<{ label: string; description?: React.ReactNode; value: string }>(
		value || options[0],
	);

	return (
		<div className="sm:w-full sm:max-w-lg mx-auto px-4">
			{label ? <p className="text-[#111928] text-sm font-medium font-inter text-left mr-auto mb-2">{label}</p> : null}

			<div className="w-full flex justify-center bg-white rounded-[8px] border border-[#7777E7]">
				{options.map(item => (
					<button
						onClick={() => {
							setSelected(item);
							onChange && onChange(item);
						}}
						key={item.value}
						className={classNames(
							'w-full md:min-w-[120px] md:max-w-[120px] flex flex-col border-r border-[#7777E7] last-of-type:border-r-0 items-center text-center justify-center py-[5px] md:py-[10px] px-[1px]',
							selected?.value === item.value
								? 'text-[#7777E7] [background:linear-gradient(0deg,_rgba(119,_119,_231,_0.20)_0%,_rgba(119,_119,_231,_0.20)_100%)] '
								: 'text-[#555770]',
						)}
					>
						<h4 className="text-base md:text-lg font-medium">{item.label}</h4>
						<p className="text-xs md:text-[13px] mt-1 text-[#555770] font-normal">{item.description}</p>
					</button>
				))}
			</div>
		</div>
	);
};

export default AuthSelector;
